var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnhanceComfort4Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8361_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16C3 8.26801 9.26801 2 17 2H29C36.732 2 43 8.26801 43 16V28C43 35.732 36.732 42 29 42H17C9.26801 42 3 35.732 3 28V16Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1665 15.9184C22.1663 15.8024 22.1318 15.6889 22.0672 15.5925C22.0027 15.496 21.911 15.4209 21.8037 15.3765C21.6965 15.3321 21.5785 15.3204 21.4646 15.343C21.3508 15.3656 21.2462 15.4214 21.164 15.5034L18.344 18.3226C18.2352 18.4321 18.1057 18.5189 17.9631 18.578C17.8205 18.637 17.6675 18.6672 17.5132 18.6668H15.4998C15.2788 18.6668 15.0669 18.7546 14.9106 18.9108C14.7543 19.0671 14.6665 19.2791 14.6665 19.5001V24.5001C14.6665 24.7211 14.7543 24.9331 14.9106 25.0894C15.0669 25.2456 15.2788 25.3334 15.4998 25.3334H17.5132C17.6675 25.333 17.8205 25.3632 17.9631 25.4223C18.1057 25.4813 18.2352 25.5681 18.344 25.6776L21.1632 28.4976C21.2453 28.5799 21.3501 28.636 21.4642 28.6588C21.5782 28.6815 21.6965 28.6699 21.8039 28.6253C21.9114 28.5808 22.0032 28.5054 22.0678 28.4086C22.1323 28.3118 22.1667 28.1981 22.1665 28.0818V15.9184Z",
    stroke: "#4A5565",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3335 19.5C26.8744 20.2212 27.1668 21.0985 27.1668 22C27.1668 22.9015 26.8744 23.7788 26.3335 24.5",
    stroke: "#4A5565",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1367 27.3034C29.8332 26.607 30.3856 25.7802 30.7625 24.8703C31.1395 23.9603 31.3335 22.985 31.3335 22.0001C31.3335 21.0152 31.1395 20.0399 30.7625 19.13C30.3856 18.22 29.8332 17.3932 29.1367 16.6968",
    stroke: "#4A5565",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8361_2353",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8361_2353"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8361_2353"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8361_2353",
    result: "effect2_dropShadow_8361_2353"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8361_2353",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceComfort4Icon);
export default __webpack_public_path__ + "static/media/enhance_comfort_4_icon.eaddf276e8c2ec1b39add1b7387a7547.svg";
export { ForwardRef as ReactComponent };